<!--
 * @Description: 终端要货清单
 * @Autor: txp
 * @Date: 2021-05-07 16:50:28
-->
<template>
  <div class="announcementview">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="ft20 D1D1D1">我的发货单</span>
      </div>
      <div class="select_box flex">
        <div class="select_box_input">
          <el-input
            size="small"
            placeholder="发货单编号"
            v-model="deliveryCode"
            clearable
          ></el-input>
          <el-select
            size="small"
            v-model="receivingStatus"
            clearable
            placeholder="收货状态"
          >
            <el-option
              v-for="item in selectValList"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            ></el-option>
          </el-select>
          <el-date-picker
            size="small"
            v-model="dataTime"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <el-input
            size="small"
            placeholder="收货人"
            v-model="contactsName"
            clearable
            class="margintop20"
          ></el-input>
        </div>
        <div class="select_box_btn">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="queryClick"
          >
            查询
          </el-button>
          <el-button
            size="small"
            type="primary"
            plain
            icon="el-icon-refresh-right"
            @click="resetClick"
          >
            重置
          </el-button>
        </div>
      </div>
      <div class="text item announcementview_content">
        <el-button
          size="small"
          type="primary"
          @click="confirmReceipt"
          class="marginbottom10"
        >
          发货单收货
        </el-button>
        <el-button size="small" class="marginbottom10" @click="open">
          导出
        </el-button>
        <el-table
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          height="450px"
          :header-cell-style="{
            textAlign: 'center',
            fontSize: '13px',
            color: '#787878',
            background: '#F5F5F5',
          }"
          :cell-style="{
            textAlign: 'center',
            fontSize: '14px',
            color: '#1D1D1D',
          }"
          style="width: 100%"
          :data="table_data"
          @selection-change="handleSelectionChange"
        >
          <el-table-column label="全选" type="selection"></el-table-column>
          <el-table-column
            width="100"
            prop="deliveryCode"
            label="发货单编号"
            fixed="left"
          >
            <!-- <template slot-scope="scope">
              <p class="cursorP" :style="'color:' + theme" @click="handleClickOrder(scope.row.id)">
                {{ scope.row.orderCode }}
              </p>
            </template> -->
          </el-table-column>
          <el-table-column
            v-for="(item, index) in table_data_head"
            :key="index"
            :width="item.width || '150'"
            :prop="item.prop"
            :label="item.label"
          ></el-table-column>
        </el-table>
      </div>
      <div class="pageschange">
        <el-pagination
          background
          layout="total,prev, pager, next"
          :total="total"
          :current-page.sync="pageNum"
          prev-text="上一页"
          next-text="下一页"
          @current-change="controllerList()"
        ></el-pagination>
      </div>
    </el-card>
    <ExportModal
      v-if="visible"
      :visible="visible"
      :params="modalParams"
      @onClose="close"
    ></ExportModal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { mydeliveryOrder, mdmdictdata, confirmReceipt } from '@/api/api'
import { /* OrderDetailEs, */ ChangeOrderStatus } from '@/api/terminalOrderlist'
import ExportModal from '@/components/export_modal/export_modal.vue'
import { getUuid } from '@/utils'

export default {
  name: 'announcementview',
  data() {
    return {
      deliveryCode: '', //发货单订单编号
      receivingStatus: '', //收货状态
      contactsName: '', // 收货人
      tableHeight: '',
      screenHeight: window.innerHeight,
      dataTime: [],
      table_data_head: [
        { label: '发货时间', prop: 'deliverDate', width: 100 },
        { label: '订单编码', prop: 'orderCode', width: 200 },
        { label: 'SAP订单编码', prop: 'sapOrderCode', width: 120 },
        { label: '客户编码', prop: 'customerCode', width: 100 },
        { label: '客户名称', prop: 'customerName' },
        { label: '产品编码', prop: 'productCode', width: 120 },
        { label: '产品名称', prop: 'productName' },
        // { label: '产品描述', prop: 'b' },
        { label: '行项目类别描述', prop: 'lineTypeName', width: 120 },
        { label: '商品数量', prop: 'productNum', width: 100 },
        // { label: '总重量（KG）', prop: 'weightOfKilogram' },
        { label: '实际支付（元）', prop: 'deliverAmount' },
        { label: '收货状态', prop: 'receivingStatusName', width: 100 },
        { label: '收货人', prop: 'contactsName', width: 100 },
        { label: '收货地址', prop: 'pickAddress', width: 300 },
      ],
      table_data: [], // 1.list分页展示接口接受参数
      loading: false,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      selectValList: [], //发货单状态数据字典
      lineTypeData: [], //行项目数据字典
      selectRow: [], //选中数据
      visible: false,
      modalParams: {},
    }
  },
  components: {
    ExportModal,
  },
  watch: {
    screenHeight() {
      this.$nextTick(() => {
        this.setPageHeight()
      })
    },
  },
  computed: {
    ...mapGetters({
      theme: 'theme',
    }),
  },
  created() {
    this.controllerList()
    // this.mdmdictdatas();
    // this.lineTypedatas();
  },
  mounted() {
    this.$nextTick(() => {
      this.setPageHeight()
    })
  },
  methods: {
    setPageHeight() {
      const pageHeight = window.innerHeight
      this.tableHeight = pageHeight - 550
    },
    // 获取发货单状态数据字典
    async mdmdictdatas() {
      await mdmdictdata({
        dictTypeCode: 'hd_order_receiving_status',
      }).then((res) => {
        if (res.code == 200) {
          this.selectValList = res.result
        }
      })
    },
    // 获取行项目数据字典
    async lineTypedatas() {
      await mdmdictdata({
        dictTypeCode: 'dms_order_line_type',
      }).then((res) => {
        if (res.code == 200) {
          this.lineTypeData = res.result
        }
      })
    },
    // 获取终端要货列表
    controllerList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deliveryCode: this.deliveryCode,
        receivingStatus: this.receivingStatus,
        startTime: this.dataTime && this.dataTime.length > 0 ? this.dataTime[0] : '',
        endTime: this.dataTime && this.dataTime.length > 0 ? this.dataTime[1] : '',
        contactsName: this.contactsName,
      }
      this.loading = true
      mydeliveryOrder({ ...params }).then(async (res) => {
        await this.mdmdictdatas() //请求
        await this.lineTypedatas()
        this.total = res.result.count
        let companyData = res.result.data.map((item) => {
          let obj = { ...item }
          try {
            obj.receivingStatusName = item.receivingStatus
              ? this.selectValList.find(
                  (it) => it.dictCode == item.receivingStatus
                ).dictValue
              : ''
          } catch {
            obj.receivingStatusName = ''
          }
          try {
            obj.lineTypeName = item.lineType
              ? this.lineTypeData.find((it) => it.dictCode == item.lineType)
                  .dictValue
              : ''
          } catch {
            obj.lineTypeName = ''
          }
          return obj
        })
        this.table_data = companyData
        this.loading = false
      })
    },
    //  查询
    queryClick() {
      this.controllerList()
    },
    // 重置
    resetClick() {
      ;(this.pageNum = 1),
        (this.pageSize = 10),
        (this.receivingStatus = ''),
        (this.deliveryCode = ''),
        (this.dataTime = [])
      this.controllerList()
    },
    // 订单号查看
    handleClickOrder(id) {
      this.$router.push({
        path: '/home/main/terminallistdet',
        query: {
          id,
        },
      })
    },
    // 确认订单 / 取消订单
    handleClick(row, status) {
      let params = {
        approvalStatus: status,
        id: row.id,
      }
      ChangeOrderStatus(params).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message)
          this.controllerList()
        }
      })
    },
    // 获取选中的值
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //发货单收货
    confirmReceipt() {
      if (this.selectRow.length === 0) {
        this.$message.error('请先选择发货单')
        return
      }
      confirmReceipt({
        orderCodes: this.selectRow.map((item) => item.orderCode),
        deliveryCodes: this.selectRow.map((item) => item.deliveryCode),
      }).then(() => {
        this.$message.success('收货成功')
        this.queryClick()
        // this.$router.back()
      })
    },
    // 打开弹框
    open() {
      this.modalParams = {
        sid: getUuid(32, 16),
        functionCode: 'master_list',
        parentCode: 'CRM20210611000001566',
        requestUrl: '/order/dmsHdDeliverGoodsController/pageList',
        import_terminal: 'front',
        deliveryCode: this.deliveryCode,
        receivingStatus: this.receivingStatus,
        startTime: this.dataTime && this.dataTime.length > 0 ? this.dataTime[0] : '',
        endTime: this.dataTime && this.dataTime.length > 0 ? this.dataTime[1] : '',
        contactsName: this.contactsName,
      }
      this.visible = true
    },
    // 关闭弹框
    close() {
      this.visible = false
      this.modalParams = {}
    },
  },
}
</script>
<style lang="scss">
.margintop20{
  margin-top: 20px;
}
.marginbottom10 {
  margin-bottom: 10px;
}
.announcementview {
  width: 1020px;
  height: 100%;
  .el-card {
    height: 100%;
    .el-card__header {
      border-bottom: 0;
      padding: 20px 20px 0px 20px;
    }
    .el-table .success-row {
      background: #fafafa;
    }
    .select_box {
      margin-bottom: 20px;
      .select_box_input {
        flex: 1;
        .el-input {
          width: 200px;
          margin-right: 20px;
        }
        .el-input__inner {
          border-radius: 2px;
          background: #f5f5f5;
        }
        .el-range-input {
          background: #f5f5f5;
        }
        .el-range-editor--small.el-input__inner {
          width: 236px !important;
          margin-right: 20px;
        }
      }
      .select_box_btn {
        width: 240px;
        text-align: right;
      }
    }
    .el-table__fixed-right::before {
      height: 0;
    }
    // 分页
    .pageschange {
      margin: 20px auto;
      text-align: center;
    }
    .el-table__body-wrapper::-webkit-scrollbar {
      height: 5px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      background-color: #fafafa;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: $color-primary;
    }
  }
}
</style>
